import { render } from "./AddFreeDays.vue?vue&type=template&id=1633a2ad&scoped=true"
import script from "./AddFreeDays.vue?vue&type=script&lang=js"
export * from "./AddFreeDays.vue?vue&type=script&lang=js"

import "./AddFreeDays.vue?vue&type=style&index=0&id=1633a2ad&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1633a2ad"]])

export default __exports__